import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GatewayUpdateCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/update-customer.model';
import { UpdateCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/customers-service-lib/src/wrapper/inputs/customers/update-customer.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomerUpdateFormStep1Controller } from '@app/feature/customer/customer-update/customer-update-form-step-1/customer-update-form-step-1.controller';
import { CustomerUpdateFormStep2Controller } from '@app/feature/customer/customer-update/customer-update-form-step-2/customer-update-form-step-2.controller';
import { useUpdateCustomerContext } from '@app/feature/customer/customer.context';

interface CustomerUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<UpdateCustomerModel, 'customerId'> & {
      customer: GatewayUpdateCustomerModel;
    }
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<UpdateCustomerModel, 'customerId'> & {
      customer: GatewayUpdateCustomerModel;
    }
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const CustomerUpdateFormController = (
  props: CustomerUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useUpdateCustomerContext();

  return (
    <MultiStepFormProvider<
      Pick<UpdateCustomerModel, 'customerId'> & {
        customer: GatewayUpdateCustomerModel;
      }
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.customer-update.step-1.title'),
          iconName: 'dataflow-04',
          fields: [
            'customer.name',
            'customer.holder.companyName',
            'customer.holder.siret',
            'customer.holder.vatNumber',
            'customer.holder.address.address',
            'customer.holder.address.city',
            'customer.holder.address.zipCode',
            'customer.holder.address.countryCode',
            'customer.holder.firstName',
            'customer.holder.lastName',
            'customer.holder.email',
          ],
          component: <CustomerUpdateFormStep1Controller />,
        },
        {
          title: t('$.customer-update.step-2.title'),
          iconName: 'marker-pin-04',
          fields: [
            'customer.commissionPercentage',
            'customer.billingDetails.firstName',
            'customer.billingDetails.lastName',
            'customer.billingDetails.address.address',
            'customer.billingDetails.address.city',
            'customer.billingDetails.address.zipCode',
            'customer.billingDetails.address.countryCode',
            'customer.billingDetails.bic',
            'customer.billingDetails.iban',
            'customer.billingDetails.mandate.dateOfSignature',
            'customer.billingDetails.mandate.documentNumber',
            'customer.isExemptFromBilling',
          ],
          component: <CustomerUpdateFormStep2Controller />,
        },
      ]}
    />
  );
};
